import React from 'react';

import { ImInfinite } from 'react-icons/im';
import { FaIndustry } from 'react-icons/fa';
import { FaSeedling } from 'react-icons/fa';

// Import images
import multiplicacionSemillasImg from '../assets/features/multiplicacion-de-semillas.jpg';
import semillasRadixagroImg from '../assets/features/semillas-radixagro.png';
import plantaClasificacionImg from '../assets/features/planta-de-clasificacion.png';

const iconStyle = (Icon) => <Icon size="3rem" color="#ffffff" />;

export const featuresData = [
	{
		name: 'Semillas',
		description: 'Amplio catálogo de semillas forrajeras, pasturas y cultivos especializados, seleccionadas por su adaptabilidad y rendimiento superior.',
		icon: iconStyle(FaSeedling),
		image: semillasRadixagroImg,
		imgClass: 'two',
		link: './productos'
	},
	{
		name: 'Multiplicación de semillas',
		description: 'Producción de semillas de alta calidad para el sector agropecuario, garantizando pureza genética y excelente germinación.',
		icon: iconStyle(ImInfinite),
		image: multiplicacionSemillasImg,
		imgClass: 'one',
		link: './multiplicacióndesemillas'
	},
	{
		name: 'Planta clasificadora',
		description: 'Instalaciones modernas para el procesamiento, limpieza y clasificación de semillas, asegurando los más altos estándares de calidad.',
		icon: iconStyle(FaIndustry),
		image: plantaClasificacionImg,
		imgClass: 'four',
		link: './planta'
	}
];